export default {
  NOTIFICATION_STATE: {
    UPDATE_CREDENTIALS: 'updateCredentials',
    NEW_CREDENTIALS: 'newCredentials',
    ACCOUNT_QUESTIONS: 'accountQuestions',
    MERGE_QUESTIONS: 'mergeQuestions',
    CASHFLOW_QUESTIONS: 'cashflowQuestions',
    TECHNICAL_ERROR: 'technicalError',
    SYSTEM_BUG: 'systemBug',
    CUSTOMER_BUG: 'customerBug',
    TRIAL_EXPIRED: 'trialExpired',
    DORMANT_AFTER_CANCELED: 'dormantAfterCanceled',
    MALICIOUS_MEMBER_JOINED: 'maliciousMemeberJoined',
    TOUR: 'tour',
    NONE: 'none',
    PROCESSING_CASHFLOW: 'processingCashflow',
  },
  CASHFLOW_STATE: {
    OUT_OF_DATE: 'outOfDate',
    ACTIVE: 'active',
    BLOCKED: 'blocked',
    BUG: 'bug',
    PENDING: 'pending',
  },
  BAR_STATE: {
    OUT_OF_DATE: 'outOfDate',
    NOT_ACCURATE: 'notAccurate',
    NOT_AVAILABLE: 'notAvailable',
    PROCESSING: 'processing',
  },
};
